import { createContext } from 'react';

import { SchemaTree } from '@atom/types/schema';

import { ElementSelection } from './addElementsModalUtilities';

export type ElementSelectionContextValue = {
  selection: ElementSelection;
  expanded: Set<string>;
  onToggle: (element: SchemaTree, path: string[]) => void;
  onQuantityChange: (path: string[], value: string) => void;
  onToggleExpanded: (key: string) => void;
};

const ElementSelectionContext = createContext<ElementSelectionContextValue>({
  selection: {},
  expanded: new Set(),
  onToggle: () => {},
  onQuantityChange: () => {},
  onToggleExpanded: () => {},
});

export default ElementSelectionContext;
